import axios from "axios";
import {formatoMoneda} from "../Utilidades/formatoMoneda";

export const enviarMensajeNuevoPedido = ({nombre, consecutivo, ciudad, valor, numero}) => {


    let data = JSON.stringify({
        "nombre": nombre,
        "consecutivo": consecutivo,
        "ciudad": ciudad,
        "valor": formatoMoneda(valor),
        "numero": numero
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
       // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/1cc8f6e2-013a-4819-b8e9-c39fc4c4888f', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/1cc8f6e2-013a-4819-b8e9-c39fc4c4888f',
        headers: {
            'Content-Type': 'application/json'
        },
        data : data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}